<template>
  <GuestLayout>
    <div class="frosted-glass m-auto w-min flex flex-col overflow-hidden rounded-3xl p-10 backdrop-blur-md duration-300 ease md:w-auto md:pl-5">
      <div class="flex flex-wrap items-center justify-center gap-5 lg:grid lg:grid-cols-2">
        <div class="flex items-center justify-center p-6">
          <img
            alt="Logo"
            class="w-52 select-none"
            draggable="false"
            :src="LogoBlankText">
        </div>
        <form
          class="w-60 flex flex-col md:w-80"
          @submit.prevent="login">
          <BaseInput
            v-model="form.email"
            autocomplete="email"
            :error="form.errors.email"
            hide-asterisk
            label="E-Mail"
            name="email"
            special
            :theme="currentThemeIssues"
            type="email" />
          <BaseInput
            v-model="form.password"
            autocomplete="current-password"
            :error="form.errors.password"
            hide-asterisk
            label="Passwort"
            name="password"
            special
            :theme="currentThemeIssues"
            type="password" />
          <BaseCheckbox
            v-model="form.remember"
            label="Eingeloggt bleiben"
            special
            :theme="currentThemeIssues" />
          <BaseButton
            class="mt-5"
            label="Login"
            special
            :theme="currentThemeIssues"
            type="submit" />
        </form>
      </div>
    </div>
  </GuestLayout>
</template>

<script setup lang="ts">
import LogoBlankText from 'assets/supsign_logo_blank_text.svg';
import { currentThemeIssues } from '@/helpers/settings';

const form = useForm({
  email: undefined,
  password: undefined,
  remember: false,
});

function login() {
  form.post(route('login.store'), {
    onError: () => form.reset('password'),
  });
}
</script>

<style scoped>
.frosted-glass {
  border: solid 8px #FFFFFF3A;
  box-shadow: inset 0 0 80px 40px #FFF3;
}
[data-theme-hub="dark"] .frosted-glass {
  border: solid 8px #0006;
  box-shadow: inset 0 0 120px 50px #0005;
}
</style>
